<template>
  <b-server-table
    :key="tableKey"
    :filter-props="{
      filterMap: [{ key: 'search' }],
    }"
    :headers="numberReservationHeaders"
    :request-func="numberReservationList">
    <template #item.registrationNumber="{ item }">
      <span
        :class="{
          'text-decoration-line-through text-medium-emphasis':
            item.status === 'used',
        }"
        class="font-weight-bold text-decoration-none text-purple-accent-4">
        {{ item.registrationNumberDisplay || '---' }}
      </span>
    </template>

    <template #item.journal="{ item }">
      <span class="font-weight-medium text-high-emphasis">
        {{ item.journal?.name || '---' }}
      </span>
    </template>

    <template #item.author="{ item }">
      <div class="d-flex flex-column">
        <span class="font-weight-medium text-high-emphasis">
          {{ getPersonName(item.author) || '---' }}
        </span>
        <span class="text-medium-emphasis">
          {{ item.author?.post || '---' }}
        </span>
      </div>
    </template>

    <template #item.reservedBy="{ item }">
      <span class="text-medium-emphasis">
        {{
          getPersonName(item.reserved_by, {
            initials: true,
          }) || '---'
        }}
      </span>
    </template>

    <template #item.reservedAt="{ item }">
      <span class="text-medium-emphasis">
        {{ new CustomDate(item.reservedAt).toString() || '—' }}
      </span>
    </template>

    <template #item.status="{ item }">
      <v-chip color="grey-lighten-3" size="small">
        <span class="font-weight-bold text-grey-darken-1">
          {{ getStatusLabel(item.status) }}
        </span>
      </v-chip>
    </template>

    <template #item.actions="{ item }">
      <b-action-menu
        v-if="item.status === 'reserved'"
        :actions="[
          {
            title: 'Видалити',
            icon: 'mdi-delete-forever',
            action: () => deleteReservation(item.id),
            listItemProps: { class: 'text-error' },
            iconProps: { color: 'error' },
          },
        ]"
        :btnProps="{ density: 'compact' }" />
    </template>

    <template #bottom></template>
    <template #action-button>
      <create-reservation @created="refreshTable" />
    </template>
  </b-server-table>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { BServerTable, BActionMenu } from 'best-modules/components'
import { CustomDate, getPersonName } from 'best-modules/utils'
import {
  numberReservationList,
  numberReservationDelete,
} from '@/requests/document-registration'
import { numberReservationHeaders } from '@/utils/tableHeaders'
import CreateReservation from '@/pages/registration/reservation/CreateReservation.vue'

defineOptions({
  name: 'Reservation',
})

const tableKey = ref<number>(1)

const refreshTable = () => {
  tableKey.value += 1
}

const deleteReservation = (id: number) => {
  numberReservationDelete(id).then(refreshTable)
}

const getStatusLabel = (status: string) => {
  const labels: Record<string, string> = {
    reserved: 'Доступний',
    used: 'Використано',
  }

  return labels[status] || status || '—'
}
</script>
